import { styled } from '@mui/material';
import { useLocation } from 'react-router';
import { font } from 'src/constants/fontSizes';
import { spacing } from 'src/constants/spacing';
import GenericFooter from './components/GenericFooter';
import PartsCatalogueFooter from './components/PartsCatalogueFooter';

interface FooterProps {
  position?: string;
  transparent?: boolean;
}

const innerFooterHeight = '2.25rem';

const shouldForwardProp = (prop: string) => !['position', 'transparent'].includes(prop);

const StyledFooter = styled('div', { shouldForwardProp })<FooterProps>`
  font-size: ${font.xSmall};
  display: flex;
  padding: ${({ transparent }) =>
    `0 ${transparent ? /* istanbul ignore next */ spacing.smallSpacing : spacing.mediumSpacing}`};
  background: ${({ theme, transparent }) =>
    transparent ? /* istanbul ignore next */ 'transparent' : theme.palette.primary.main};
  width: 100%;
  border-top: ${({ theme, transparent }) =>
    transparent ? /* istanbul ignore next */ `2px solid ${theme.palette.primary.contrastText}` : 'none'};
  align-items: center;
  justify-content: space-between;
  height: ${innerFooterHeight};
  color: ${({ theme }) => theme.palette.primary.contrastText};
  bottom: 0;
  position: ${({ position }) => position || 'inherit'};
  flex-shrink: 0;
`;

export function Footer(props: Readonly<FooterProps>) {
  const location = useLocation();
  const isPartsCatalogue = location.pathname.includes('parts-catalogue');

  return (
    <StyledFooter data-testid="footer" {...props}>
      {isPartsCatalogue ? <PartsCatalogueFooter /> : <GenericFooter />}
    </StyledFooter>
  );
}
